<script>import Input from "./inputs/Input.svelte";
import SVG from "./SVG.svelte";
export let props;
let input = null;
let toggler = null;
let isErrorDisplayed;
const handleChange = () => {
  props.checked = input.checked;
  props = props;
};
</script>

<Input bind:props bind:isErrorDisplayed isLabelHidden={true}>
	<label
		bind:this={toggler}
		for={props.id}
		class="flex items-center justify-between cursor-pointer gap-3"
		class:checked={props.checked}
		class:disabled={props.disabled}
	>
		<span class="font-bold">{props.label}</span>
		<span
			class="shrink-0 relative transition-colors rounded-full border-2 w-[52px] h-[32px] {props.checked
				? 'bg-primary border-transparent'
				: 'bg-grey-lighter border-grey'}"
		>
			<span
				class="absolute transition-all left-1 top-1/2 -translate-y-1/2 w-[24px] h-[24px] rounded-full flex items-center justify-center {props.checked
					? 'left-[22px] text-primary bg-white'
					: 'text-grey-lighter bg-grey'}"
			>
				{#if props.checked}
					<SVG name="check" size="small" />
				{:else}
					<SVG name="close" size="small" />
				{/if}
			</span>
		</span>
		<input
			type="checkbox"
			class:hidden={true}
			id={props.id}
			checked={props.checked}
			disabled={props.disabled}
			bind:this={input}
			on:change={handleChange}
			on:change
		/>
	</label>
</Input>
